import { "profile-editors.previous_empty" as previousEmptyText } from "@repo/i18n";
import type { ReactNode } from "react";
import { Scrubber } from "../../../ui/gesture";
import { FieldError, InfoNote } from "./parts";

export interface BigNumberFormProps {
  error?: string;
  format?: (value: number) => string;
  label: string;
  max: number;
  min: number;
  onChange: (value: number) => void;
  /** The last stored value, for the "anterior" line; `null` when none. */
  previous: number | null;
  step: number;
  /** A2's info line under the dial ("De manhã, em jejum…"). */
  tip?: ReactNode;
  unit: string;
  value: number;
}

/**
 * A2's `NumberSheet` / `WeightSheet` / `BodyFatSheet` body: one big number
 * dragged sideways. It is T17's `Scrubber` in `slider` mode, which keeps what
 * A2's `big-number.tsx` had — `role="slider"`, arrows, PageUp/PageDown and
 * Home/End, and a haptic per step through `impact()` from `src/native`.
 */
export function BigNumberForm({
  label,
  value,
  onChange,
  min,
  max,
  step,
  unit,
  previous,
  format,
  tip,
  error,
}: BigNumberFormProps) {
  return (
    <div>
      <Scrubber
        format={format}
        label={label}
        max={max}
        min={min}
        onChange={onChange}
        previous={previous}
        previousEmpty={previousEmptyText()}
        role="slider"
        step={step}
        unit={unit}
        value={value}
      />
      {error ? <FieldError>{error}</FieldError> : null}
      {tip ? <InfoNote>{tip}</InfoNote> : null}
    </div>
  );
}
